import { render, staticRenderFns } from "./servicosEndereco.vue?vue&type=template&id=28f934c3&scoped=true"
import script from "./servicosEndereco.vue?vue&type=script&lang=js"
export * from "./servicosEndereco.vue?vue&type=script&lang=js"
import style0 from "./servicosEndereco.vue?vue&type=style&index=0&id=28f934c3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28f934c3",
  null
  
)

export default component.exports